<template src="./company-contracts.html"></template>
<script>

import { Money } from "v-money";
import mixins from "../../../../mixins/mixins.js";
export default {
  mixins: [mixins],
  components: {
    Money,
  },
  data() {
    return {
      idCompany: null,
      contractId: null,
      popupContract: false,
      contract: {
        name: "",
        consultTaxSoftware: "",
        consultTaxNurse: "",
        taxClinicPercentage: "",
        taxCancelationPercentage: "",
        billed: "",
      },
      titlePopContract: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      showListContract: false,
      screenWidth: 0,
      showContract: false,
      contracts: [],
      contractsPaginated: [],
      currentx: 1,
      numPages: 0,
      windowWidth: 0,
      pagination: false,
    };
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function() {
    var vm = this;
    if (vm.testNullUndefinedEmpty(vm.$session.get("idCompany")) === false) {
      vm.idCompany = vm.$session.get("idCompany");
    }
    vm.init();
  },
  methods: {
    init() {
      var vm = this;
      vm.getContracts();
    },
    removeContract(id) {
      var vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "contract/" + id, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function(response) {
          console.log(response);
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "O plano Foi removido com sucesso!",
              color: "success",
              icon: "verified_user",
              position: "top-right",
            });
            vm.getPlan();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    changeStatus(id) {
      var vm = this;
      vm.axios
        .put(vm.$store.state.filooServer + "contract/change_status/" + id,{}, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function(response) {
          console.log(response);
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "O status foi alterado com sucesso!",
              color: "success",
              icon: "verified_user",
              position: "top-right",
            });
            vm.getPlan();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    editContract(contractId) {
      var vm = this;
      vm.popupContract = true;
      vm.titlePopContract = "Editar contrato";
      vm.contractId = contractId;
      vm.getContract();
    },
    addNewContract() {
      var vm = this;
      vm.showContract = true;
      vm.popupContract = true;
      vm.contractId = null;
      vm.titlePopContract = "Novo contrato";
      vm.contract = {
        name: "",
        consultTaxSoftware: "",
        consultTaxNurse: "",
        taxClinicPercentage: "",
        taxCancelationPercentage: "",
        billed: "",
      };
    },
    getContracts() {
      var vm = this;
      this.axios
        .get(
          vm.$store.state.filooServer +
            "company/contract/" + vm.idCompany,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          vm.contracts = response.data;
          vm.numPages = Math.ceil(vm.contracts.length / 10);
          vm.pagination = vm.numPages > 1;
          vm.changePagination();
        });
    },
    dateFormatted(date) {
      console.log(date);
      var day = date.split("/")[0];
      var month = date.split("/")[1];
      var year = date.split("/")[2];
      console.log(day, month, year);
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
      // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
    },
    dateFormattedUs(date) {
      console.log(date);
      var day = date.split("/")[0];
      var month = date.split("/")[1];
      var year = date.split("/")[2];
      console.log(day, month, year);
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
      // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
    },
    getContract() {
      var vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "contract/find_by_id/" +
            vm.contractId,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.contract = response.data;
            console.log(vm.initialDateFormated);
            console.log(vm.finalDateFormated);
            console.log(vm.contract);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveNewContract() {
      var vm = this;
      console.log(vm.contract);
      vm.axios
        .post(
          vm.$store.state.filooServer +
            "contract/" ,
          vm.contract,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "Dados salvos com sucesso!",
              color: "success",
              iconPack: "feather",
              icon: "icon-check-circle",
              position: "top-right",
            });
            vm.getContracts();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateContract() {
      var vm = this;
      vm.contract.id = vm.contractId;
      console.log(vm.contract);
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "contract/" ,
          vm.contract,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "Dados salvos com sucesso!",
              color: "success",
              iconPack: "feather",
              icon: "icon-check-circle",
              position: "top-right",
            });
            vm.popupContract = false;
            vm.getContracts();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    clickNewDate() {
      var vm = this;
      vm.newDate = true;
      vm.disabledDate = false;
    },
    clickGoBackDate() {
      var vm = this;
      vm.newDate = false;
      vm.dateUSFormat = vm.initialDate;
      vm.disabledDate = true;
    },
    clickNewHorario() {
      var vm = this;
      if (vm.numHorarios < 3) {
        vm.numHorarios = vm.numHorarios + 1;
      }
    },
    clickGoBackHorario() {
      var vm = this;
      if (vm.numHorarios > 0) {
        vm.numHorarios = vm.numHorarios - 1;
      }
    },
    changePagination() {
      const vm = this;
      const contracts = vm.contracts;
      if (vm.currentx === 1) {
        vm.contractsPaginated = contracts.slice(0, 10);
      } else {
        vm.contractsPaginated = contracts.slice(
          (vm.currentx - 1) * 10,
          vm.currentx * 10
        );
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="./company-contracts.scss">
</style>
